import OrganisationPSGList from "./OrganisationPSGList";

export default {
    list: OrganisationPSGList
};
